import React, { useEffect, useState } from "react";
import axios from "axios";
import Navbar from "../Components/Navbar";
import config from "../utils/config";
import { useNavigate, useLocation } from "react-router-dom";
export default function Services() {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
 const navigate = useNavigate();
  const getServices = async () => {
    try {
      const response = await axios.get(
        `${config.baseurl}/services/`
      );

      setServices(response.data);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getServices();
  }, []);
useEffect(() => {
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: "instant",
  });
}, []);
  return (
    <>
      <Navbar />

<section className="relative py-14 overflow-hidden">
    <video
      autoPlay
      muted
      loop
      playsInline
      className="fixed top-0 left-0 w-full h-full object-cover -z-20"
    >
      <source src="/videos/bg.mp4" type="video/mp4" />
    </video>


  <div className="absolute inset-0 bg-black/40"></div>

  <div className="relative  max-w-7xl mx-auto px-4">

    <div className="text-center mb-10">
      <h2 className="text-3xl md:text-5xl font-bold text-cyan-400">
        Our IT Services
      </h2>

      <p className="text-gray-200 text-lg mt-3 max-w-3xl mx-auto">
        We deliver innovative software solutions, web applications,
        mobile apps, cloud services, and digital transformation
        strategies that help businesses grow faster and stay ahead
        in today's competitive market.
      </p>
    </div>

    {loading ? (
      <div className="text-center text-lg text-white">
        Loading...
      </div>
    ) : services.length === 0 ? (
      <div className="text-center text-2xl font-semibold text-gray-300 mt-20">
        No Services Currently Available
      </div>
    ) : (
      <div className="flex flex-wrap justify-center gap-6">

        {services.map((service) => (

          <div
            key={service.id}
            className="
              w-full
              sm:w-[350px]
              md:w-[320px]
              lg:w-[350px]
              bg-white/10
              backdrop-blur-md
              border border-cyan-500/30
              rounded-2xl
              shadow-2xl
              overflow-hidden
              hover:-translate-y-2
              transition
              duration-300
            "
          >
            <img
              src={service.image}
              alt={service.title}
              className="w-full h-52 object-cover"
            />

            <div className="p-5">

              <h3 className="text-xl font-bold text-cyan-400 mb-3">
                {service.title}
              </h3>
    <div className="mb-6 h-40 overflow-y-auto pr-2 hide-scrollbar">
              <p className="text-gray-200 text-sm">
                {service.description}
              </p>
</div>
            </div>

          </div>

        ))}

      </div>
    )}

  </div>

</section>
  <div className="bg-black/70 backdrop-blur-md py-12">

        <div className="max-w-7xl mx-auto px-5">

          <div className="grid md:grid-cols-3 gap-10">

            <div>

              <h3 className="text-xl font-bold text-cyan-400 mb-3">
                Kerala Branch
              </h3>

              <p className="leading-7 text-white">
                1st Floor - JK Building
                <br />
                Kannur, Kannur 670684
                <br />
                Phone: +91 90000 90000
              </p>

              <h3 className="text-xl font-bold text-cyan-400 mt-6 mb-3">
                Tamil Nadu Branch
              </h3>

              <p className="leading-7 text-white">
                First Floor, D Block,
                <br />
                JK Park, chennai,
                <br />
                Chennai, Tamil Nadu 600100
                <br />
                Phone: +91 70000 80000
                <br />
                Email: jk@gmail.com
              </p>

            </div>

            <div>

              <h3 className="text-xl font-bold text-cyan-400 mb-5">
                Quick Links
              </h3>

              <ul className="space-y-3 text-white">

                <li  className="cursor-pointer" onClick={() => navigate("/home")}>Home</li>
                <li  className="cursor-pointer" onClick={() => navigate("/about")}>About Us</li>
                <li className="cursor-pointer"  onClick={() => navigate("/services")}>Services</li>
                <li  className="cursor-pointer" onClick={() => navigate("/product")}>Products</li>
             

              </ul>

            </div>

            <div>

              <h3 className="text-xl font-bold text-cyan-400 mb-5">
                More Links
              </h3>

              <ul className="space-y-3 text-white">

                <li  className="cursor-pointer" onClick={() => navigate("/careers")}>Career</li>
                <li className="cursor-pointer"  onClick={() => navigate("/events")}>Events</li>
                <li  className="cursor-pointer" onClick={() => navigate("/blogs")}>Blogs</li>

              </ul>

            </div>

          </div>

        </div>

      </div>
    </>
  );
}